import { postOnixImportReportSchedule } from "reedy-data/api";
import { BaseApi } from "./base";

export class ReportsApi extends BaseApi {
  async scheduleOnixImportReport(onixImportReportId: string) {
    const response = await this.request(
      postOnixImportReportSchedule as any,
      {
        body: { onixImportReportId } as any,
        headers: { "Content-Type": "application/json" },
      } as any,
    );

    return response as { exportId: string };
  }
}
